export default __webpack_public_path__ + "static/avatar-2a6d18ead4442d3ebf28ea27e8cc260a.jpeg";